export default function Showcase({ settings }) {
  const img = (settings.showcase_image_url || "").trim();

  if (!img) {
    // Render nothing if no showcase image is configured – keep page lean
    return null;
  }

  return (
    <section className="border-b border-white/10" data-testid="showcase-section">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-14 md:py-24">
        <div className="mb-8 md:mb-12">
          <div className="text-[11px] uppercase tracking-[0.3em] text-mfp-gold font-bold mb-3">
            Hinter den Kulissen
          </div>
          <h2 className="font-display text-3xl md:text-5xl uppercase leading-[1.05]">
            Echte Sets.<br />
            <span className="text-mfp-gold">Echte Ergebnisse.</span>
          </h2>
        </div>

        <div className="relative w-full overflow-hidden rounded-2xl group">
          <img
            src={img}
            alt="MediaFly Production – Set"
            loading="lazy"
            width="1920"
            height="1080"
            className="block w-full h-auto"
            data-testid="showcase-image"
          />
        </div>
      </div>
    </section>
  );
}
